import { APP_ROUTES } from '@/constants/constants';
import { useGetBoardPermissionQuery } from '@/hooks/api/useGetBoardPermissionQuery';
import useGetContextQuery from '@/hooks/api/useGetContextQuery';
import { useGetSessionToken } from '@/hooks/api/useGetSessionToken';
import usePlatform from '@/hooks/usePlatform';
import { preloadRoute } from '@/utils/navigation';
import { Button, IconButton, Skeleton, Tooltip } from '@vibe/core';
import { Close, Settings } from '@vibe/icons';
import { useEffect, useMemo } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';
import HeaderContainer from '../Header/HeaderContainer';

const SettingsButton = () => {
  const navigate = useNavigate();
  const { data: context, isLoading: isLoadingContext } = useGetContextQuery();
  const boardId = context?.boardId;

  const { data: sessionToken, isLoading: isLoadingSessionToken } =
    useGetSessionToken();

  const isViewOnly = sessionToken?.dat?.is_view_only;
  const userId = sessionToken?.dat?.user_id;

  const { data: isAllowed, isLoading: isLoadingBoardPermission } =
    useGetBoardPermissionQuery(boardId ?? 0, userId ?? 0);

  const navigateToSettings = () => navigate(APP_ROUTES.SETTINGS);

  const isLoading =
    isLoadingContext || isLoadingBoardPermission || isLoadingSessionToken;

  const isSettingsAllowed = useMemo(() => {
    return isAllowed && !isViewOnly;
  }, [isAllowed, isViewOnly]);

  const tooltipContent = useMemo(() => {
    return !isSettingsAllowed
      ? 'Only board owners are allowed to update the settings.'
      : '';
  }, [isSettingsAllowed]);

  if (isLoading) return <Skeleton width={96} height={32} />;

  return (
    <Tooltip content={tooltipContent}>
      <Button
        kind={Button.kinds.SECONDARY}
        size={Button.sizes.SMALL}
        onClick={navigateToSettings}
        leftIcon={Settings}
        disabled={!isSettingsAllowed}
      >
        Settings
      </Button>
    </Tooltip>
  );
};

const Header2 = () => {
  const navigate = useNavigate();
  const { isMobile } = usePlatform();
  const isSetupPage = useMatch(APP_ROUTES.SETUP);
  const isSettingsPage = useMatch(APP_ROUTES.SETTINGS);

  useEffect(() => {
    if (isSetupPage) {
      preloadRoute(APP_ROUTES.SETTINGS);
    }
  }, [isSetupPage]);

  useEffect(() => {
    if (isSettingsPage) {
      preloadRoute(APP_ROUTES.SETUP);
    }
  }, [isSettingsPage]);

  const navigateToSetup = () => navigate(APP_ROUTES.SETUP);

  return (
    <HeaderContainer>
      {!!isSetupPage && !isMobile && <SettingsButton />}
      {!!isSettingsPage && (
        <IconButton
          icon={Close}
          kind={Button.kinds.TERTIARY}
          size={Button.sizes.SMALL}
          onClick={navigateToSetup}
        />
      )}
    </HeaderContainer>
  );
};

export default Header2;
